export default class SortedEnumDataSource {
  // Store the data as Map to preserve the original
  // order of the enum values
  data: Map<string | number, string>;

  constructor(data: Map<string | number, string>) {
    if (data && data.size > 0) {
      this.data = data;
    } else {
      // Handle the case when data is null or empty
      // For example, initialize data to an empty Map
      this.data = new Map();
    }
  }

  addOption(code: string | number, value: string) {
    this.data.set(code, value);
  }

  getFromCode(code?: string | number | null): string {
    if (code === null || code === undefined) {
      return "";
    }
    return this.data.get(code) || "";
  }

  getOptions(excludeCodes: string[] = []) {
    return Array.from(this.data.entries())
      .filter(([code]) => !excludeCodes.includes(String(code)))
      .map(([code, label]) => ({ value: code, label }));
  }

  getOptionsSortedByLabel(excludeCodes: string[] = []) {
    return Array.from(this.data.entries())
      .filter(([code]) => !excludeCodes.includes(String(code)))
      .map(([code, label]) => ({ value: code, label }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }

  getCodes() {
    return Array.from(this.data.keys());
  }

  getValues() {
    return Array.from(this.data.values());
  }
}
